var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReceiptSearch = function SvgReceiptSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.8c0-.4.4-.5.7-.3l.8.8c.2.2.4.2.6 0l1.2-1.2c.1-.1.3-.1.5 0L8 2.4c.2.2.4.2.6 0l1.2-1.2c.2-.2.4-.2.6 0l1.2 1.2c.2.2.4.2.6 0l1.2-1.2c.2-.2.4-.2.6 0l1 1.2c.2.2.4.2.6 0l.8-.8c.2-.3.6-.1.6.2V7c0 .4-.5.6-.8.3-1.1-1-2.5-1.5-4-1.5-3.4 0-6.1 2.8-6.1 6.2 0 2.1.7 3.1 1.5 4.2l.6.9c.1.1.1.3-.1.5l-1.3 1.3c-.2.2-.4.2-.6 0L5 17.6c-.2-.2-.4-.2-.6 0l-.8.8c-.2.3-.6.1-.6-.2V1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 16.2c.8 0 1.5-.2 2.1-.6l3.1 3.1 1.4-1.4-3.1-3.1c.4-.6.6-1.3.6-2.1 0-2.3-1.8-4.1-4.1-4.1S8 9.8 8 12.1c0 2.2 1.8 4.1 4.1 4.1zm0-2c1.1 0 2.1-.9 2.1-2.1s-1-2.1-2.1-2.1-2.1.9-2.1 2.1.9 2.1 2.1 2.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgReceiptSearch;